<template>
    <RouterLink v-if="showOwnerId || showLogo"
                 :to="homeLink"
                 :class="[showOwnerId && !showLogo ? 'navbar-id' : 'navbar-logo', viewData.navOpen ? 'nav-open' : '']"
    >
        <!-- user name -->
        <template v-if="showOwnerId && !showLogo">
            {{viewData.user.name}}
        </template>

        <!-- logo -->
        <template v-if="showLogo">
            <img :src="logoUrl"
                 :height="logoHeight"
                 alt="Portfolio logo"
            >
        </template>

    </RouterLink>
</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: 'GetSiteLogo',
    computed: {
        ...mapGetters("view", ["viewData", "normalizedHost"]),
        portfolio() {
            return this.viewData.portfolio
        },
        homeLink() {
            return this.portfolio.ownDomainAddress && this.portfolio.ownDomainAddress.toLowerCase() === this.normalizedHost
                ? '/'
                : `/${this.portfolio.shortId}`
        },
        resolvedLogo() {
            return this.portfolio?.logo || this.portfolio?.templateSettings?.logo || null;
        },
        logoUrl() {
            const logo = this.resolvedLogo;
            if (!logo) return null;
            if (logo.media) return logo.media.croppedImageUrl || logo.media.url;
            if (logo.image) return logo.image.url;
            return null;
        },
        logoHeight() {
            const logo = this.resolvedLogo;
            if (!logo) return 48;
            const height = logo.media ? logo.media.height : (logo.image ? logo.image.height : null);
            return height || 48;
        },
        showLogo() {
            let hiddenInCaseStudy = (this.$store.getters.isCaseStudy && this.portfolio.templateSettings.theme !== 'theme_seventeen') || !this.$store.getters.isCaseStudy;
            const logo = this.resolvedLogo;
            if (!logo) return false;
            const mode = logo.mode || (logo.image?.url ? "Logo" : "None");
            return mode === "Logo" && !!this.logoUrl && this.logoIsAvailableInTheme && hiddenInCaseStudy;
        },
        showOwnerId() {
            return this.portfolio.templateSettings.navigation.navigationItems.ownerId.visible
        },
        logoIsAvailableInTheme() {
            // logo supported in the following templates
            // Nelson 13, Otis 12, Bauhaus 11, Orielle 10, Nominee 8, Panorama 5, Poster
            let notAllowedInThemes = ['theme_one', 'theme_two', 'theme_three', 'theme_six', 'theme_seven', 'theme_eleven'];
            return !notAllowedInThemes.includes(this.portfolio.templateSettings.theme)
                && !this.portfolio.templateSettings.theme.includes('profile_'); // it is not allowed in legacy themes
        }
    }
}
</script>

<style lang="scss" scoped>
    .navbar-id,
    .navbar-logo {
        z-index: 2;
        position: relative;
    }

    .navbar-id,
    .navbar-id a {
        &:hover {
            font-weight: bold;
            color: var(--hero-nav-button-text-color-hover);
            cursor: pointer;
        }
    }
</style>